import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "text-lg mb-[6px]" }
const _hoisted_4 = { class: "mb-[20px] md:mb-[25px]" }
const _hoisted_5 = { class: "sm:grid sm:grid-cols-2 sm:gap-[25px]" }
const _hoisted_6 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_7 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_8 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_9 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_10 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_11 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_12 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_13 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_14 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_15 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "text-lg mb-[6px] mt-[20px] md:mt-[25px]" }
const _hoisted_18 = { class: "mb-[20px] md:mb-[25px]" }
const _hoisted_19 = { id: "fileUploader" }
const _hoisted_20 = { class: "relative flex items-center justify-center overflow-hidden rounded-md py-[88px] px-[20px] border border-gray-200 dark:border-[#172036]" }
const _hoisted_21 = {
  key: 0,
  class: "mb-4 text-center"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "text-primary-500" }
const _hoisted_24 = { class: "flex items-center justify-center" }
const _hoisted_25 = { class: "leading-[1.5]" }
const _hoisted_26 = { class: "text-black dark:text-white" }
const _hoisted_27 = { class: "mt-[20px] md:mt-[25px]" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "inline-block relative ltr:pl-[29px] rtl:pr-[29px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsNav),
      _createElementVNode("form", null, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.directT('settings.accountSettings.profile')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.directT('settings.accountSettings.updatePhotoAndDetails')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.directT('settings.accountSettings.firstName')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              value: "Olivia",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileData.first_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.profileData.first_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.directT('settings.accountSettings.lastName')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              value: "John",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileData.last_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.profileData.last_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.directT('settings.accountSettings.emailAddress')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              value: "olivia@clickai.live",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileData.email) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.profileData.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.directT('settings.accountSettings.phoneNumber')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              value: "+1 444 555 6699",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profileData.phone) = $event))
            }, null, 512), [
              [_vModelText, _ctx.profileData.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.directT('settings.accountSettings.location')), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              placeholder: _ctx.directT('settings.accountSettings.enterYourLocation'),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profileData.location) = $event))
            }, null, 8, _hoisted_16), [
              [_vModelText, _ctx.profileData.location]
            ])
          ])
        ]),
        _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.directT('settings.accountSettings.profileInfo')), 1),
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.directT('settings.accountSettings.displayedProfile')), 1),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.profileData.profile_picture_link)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("img", {
                    src: _ctx.profileData.profile_picture_link,
                    alt: "Profile Picture",
                    class: "mx-auto w-[150px] h-[150px] object-cover rounded-full mb-2"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.directT('settings.accountSettings.currentImage')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]" }, [
                _createElementVNode("i", { class: "ri-upload-2-line" })
              ], -1)),
              _createElementVNode("p", _hoisted_25, [
                _createElementVNode("strong", _hoisted_26, _toDisplayString(_ctx.directT('settings.accountSettings.clickToUpload')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.accountSettings.yourFileHere')), 1)
              ])
            ]),
            _createElementVNode("input", {
              type: "file",
              id: "fileInput",
              class: "absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer",
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleProfilePictureUpload && _ctx.handleProfilePictureUpload(...args))),
              accept: "image/*"
            }, null, 32)
          ]),
          (_ctx.uploadStatus)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["mt-2 text-center", {'text-green-500': _ctx.uploadStatus === 'success', 'text-red-500': _ctx.uploadStatus === 'error'}])
              }, _toDisplayString(_ctx.uploadStatusMessage), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            type: "button",
            class: "font-medium inline-block transition-all rounded-md md:text-md ltr:mr-[15px] rtl:ml-[15px] py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-danger-500 text-white hover:bg-danger-400",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, _toDisplayString(_ctx.directT('settings.accountSettings.cancel')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "font-medium inline-block transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args))),
            disabled: _ctx.isLoading
          }, [
            _createElementVNode("span", _hoisted_29, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2" }, " check ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? _ctx.directT('settings.accountSettings.updating') : _ctx.directT('settings.accountSettings.updateProfile')), 1)
            ])
          ], 8, _hoisted_28)
        ])
      ])
    ])
  ]))
}